import { ErrorMessage } from "@hookform/error-message"
import clsx from "clsx"
import { FieldErrors } from "react-hook-form"

const Field = ({
  label,
  name,
  children,
  errors,
  className,
}: {
  label?: string
  name: string
  children: React.ReactNode
  errors: FieldErrors
  className?: string
}) => (
  <div className={clsx(className)}>
    {label && (
      <label htmlFor={name} className="mb-1 block text-gray-700">
        {label}
      </label>
    )}
    <div>{children}</div>
    <ErrorMessage
      errors={errors}
      name={name}
      render={({ message }) => (
        <div className="mt-1 text-sm font-bold text-red-500">{message}</div>
      )}
    />
  </div>
)

export default Field
